import LongArrowRight from '~/icons/LongArrowRight';
import NotificationBell from '~/icons/NotificationBell';
import { CardDescription } from '../OrderStatusCards.styles';

type OwnProps = {
  cta: string;
  hasOpenVerifications: boolean;
  openVerificationsCount: number;
};

export const RemainingTasks = ({
  openVerificationsCount,
  hasOpenVerifications,
  cta
}: OwnProps) => {
  const taskCount =
    openVerificationsCount > 1
      ? `${openVerificationsCount} tasks`
      : `${openVerificationsCount} task`;

  return hasOpenVerifications ? (
    <div className="mt-16 w-full rounded-md bg-yellow-1 p-16 m:mt-0 m:max-w-[450px] m:p-24">
      <div className="flex w-full items-center gap-16">
        <div className="mt-[-5px] h-40 w-40">
          <NotificationBell />
        </div>
        <span
          data-qa="order-placed-alert-text"
          className="text-sm text-blue-6 m:text-base "
        >
          You have {taskCount} to complete.
        </span>
      </div>
      <hr className="my-20 w-full border-0 border-t border-yellow-2" />
      <div
        data-qa="order-placed-cta-text"
        className="flex justify-between text-sm font-semibold text-blue-6"
      >
        {cta}
        <LongArrowRight data-qa="order-placed-right-arrow" />
      </div>
    </div>
  ) : null;
};

export const AllTasksComplete = () => (
  <CardDescription data-qa="order-placed-no-verifications-text">
    All of your tasks are complete! Sit back, relax and get excited for your new
    ride.
  </CardDescription>
);
